import PropTypes from 'prop-types';
import styled from 'styled-components';
import smartTextStyles from './smartTextStyles';

export const SmartText = styled.span`
  ${smartTextStyles}
`;

SmartText.propTypes = {
  fontFamily: PropTypes.string,
  fontSize: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string
};

export default SmartText;
